module.exports = __webpack_public_path__ + "static/media/feature-image.8e3a0de9.png";